module.exports = __webpack_public_path__ + "static/media/shoe-M.inline.ace509da.svg";